/**
 * Emit hosts for the `link` analytics group — 1 function
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { trackLegacyEvent } from '@/lib/analytics/track-legacy-event';
import { SegmentActionName, SegmentObjectName } from '@/models/analytics/segment-names';

export function trackCreatePatientProfile(input: { isFromEHR: boolean }) {
  trackLegacyEvent({
    name: SegmentObjectName.Link,
    props: {
      action: SegmentActionName.CreatePatientProfile,
      isFromEHR: input.isFromEHR,
    },
  });
}
